import axios from "axios";
import { API } from "configs/api";

export const singleOwnerApi = {
  getSingleOwner: (body) => axios.get(`${API.signup}/${body.id}`, { token: true }),
  postAccountLogs: (body) => axios.post(`${API.owners}${API.flags}`, body, { token: true }),
  deleteAccountLogs: (id) => axios.delete(`${API.owners}${API.flags}/${id}`, { token: true }),
  deleteProperty: (data) => axios.delete(`${API.owners}${API.deleteProperty}`, { data, token: true }),
  connectOwnerProperty: (body) => axios.post(`${API.owners}${API.properties}`, body, { token: true }),
  verifySingleProperty: (params) => axios.get(API.syncProperty, { token: true, params }),
  updateDoc: ({ id, ...body }) => axios.put(`${API.docs}/${id}`, body, { token: true }),
  deleteDoc: (id) => axios.delete(`${API.docs}/${id}`, { token: true }),
  createDoc: (body) => axios.post(`${API.admin}${API.docs}`, body, { token: true, formData: true }),
  sendAoA: (body) => axios.post(API.sendAoA, body, { token: true }),
  archiveOwner: ({ id, ...params }) => axios.patch(`${API.archives}/${id}`, {}, { params, token: true }),
  getOwnerReferrals: (ownerId) => axios.get(`${API.ownerReferrals}/${ownerId}`, { token: true }),
  getOwnerReferredBy: (ownerId) => axios.get(`${API.ownerReferredBy}/${ownerId}`, { token: true }),
  archiveProperty: ({ id, ...params }) => axios.post(`${API.archiveProperty}/${id}`, {}, { params, token: true }),
  deleteReferredBy: (id) => axios.delete(`${API.referrals}/${id}`, { token: true, id }),
  postReferredBy: (body) => axios.post(`${API.signup}${API.updateSender}`, body, { token: true, formData: true }),
  postReferredTo: ({ id, email }) =>
    axios.post(`${API.owners}${API.addReceiver}/${id}`, { email }, { token: true, formData: true }),
  updateReferral: (body) => axios.post(`${API.signup}${API.updateSender}`, body, { token: true }),
  updateAccountNumber: (params) =>
    axios.put(
      `${API.owners + API.property + API.accountNumber}/${params.property_id}`,
      { account_number: params.account_number },
      { token: true }
    ),
  updateStreetAddress: (params) =>
    axios.put(
      `${API.owners + API.property + API.streetAddress}/${params.property_id}`,
      { street_address: params.street_address },
      { token: true }
    ),
  updateEmail: (owner_id, email) =>
    axios.put(`${API.owners}${API.updateEmail}/${owner_id}`, { email }, { token: true }),
  getNotes: ({ id, params }) => axios.get(`${API.getNotes}/${id}`, { token: true, params }),
  postNote: (body) => axios.post(API.notes, body, { token: true }),
  updateContactedStatus: ({ id, contacted }) =>
    axios.post(`${API.owners}${API.changeContactedStatus}/${id}`, { contacted }, { token: true }),
};
